<ae-icon-tooltip type="pending" [message]="timeZoneTemplate" />
<ng-template #timeZoneTemplate>
	<div class="text-center">
		<div>{{ text }}</div>
		<div>{{ tzDisplay }}</div>
	</div>
</ng-template>
